import axios from "axios";
import baseAxios from "./axios-utils-marketplace";

export const signInApi = (props) =>
  baseAxios.post("/users/sign_in", { user: { ...props }, source: "web" });

export const updateCollectionBuy = ({
  collectionId,
  quantity,
  transactionHash
}) => {
  return baseAxios.post("/collections/" + collectionId + "/buy", {
    quantity: quantity,
    transaction_hash: transactionHash
  });
};

export const registerApi = (props) =>
  baseAxios.post("/users", { user: { ...props } });

export const userApi = (token) =>
  baseAxios.get("/users/me", { headers: { Authorization: token } });

export const signOutApi = () => baseAxios.delete("/users/sign_out");

export const SendEmailOtp = (props) =>
  baseAxios.post("/send_email_otp", { ...props, source: "web" });

export const LoginWithOtp = (props) =>
  baseAxios.post("/login_with_otp", { ...props, source: "web" });

// export const listForSaleApi = (slug) =>
//   baseAxios.post(`/collections/${slug}/list_for_sale`);

export const SendResaleFiles = (formData, slug) =>
  baseAxios.post(`/collections/${slug}/resale`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

export const signSellOrderApi = ({
  slug,
  instant_sale_price,
  sign_instant_sale_price,
  nonce
}) => {
  return baseAxios.post(`/collections/${slug}/put_on_sale`, {
    instant_sale_price,
    sign_instant_sale_price,
    nonce
  });
};

export const OrderTrackDetails = (slug) =>
  baseAxios.get(`/collections/${slug}/shipment_details`);

export const UserTrackDetails = () => baseAxios.get(`/collections/shipments`);

// export const NFTCollectionsList = ({ page, per_page, filter = {}, sort }) => {
//   baseAxios.get(`/collections/nft_lists?page=${page}&per_page=${per_page}`, {
//     params: { filter, sort }
//   });
export const NFTCollectionsList = () => {
  return baseAxios.get(`/collections/nft_lists`);
};

export const NFTRelatedCollectionsList = (slug) => {
  return baseAxios.get(`/collections/${slug}/related_products`);
};

export const NFTCollectionsFilterList = (query) => {
  return baseAxios.get(`/collections/nft_lists?${query}`);
};

export const NotificationApi = () => {
  return baseAxios.get(`/notifications`);
};

export const NFTProductsList = () => {
  return baseAxios.get(`/products/nft_lists`);
};

export const ItemDetailsApi = ({ slug }) => {
  return baseAxios.get(`/collections/${slug}`);
};

export const SettingsApi = () => {
  return baseAxios.get("/settings");
};

export const DaoViewListApi = (status) => {
  return baseAxios.get(`/questions?type=${status}`);
};

export const DaoVoteSubmitApi = (data) => {
  return baseAxios.post("/question_option_users", data);
};

export const NftListForStakingApi = ({ method, address }) => {
  return baseAxios.get(
    `collections/nft_lists?stake=${method}&address=${address}`
  );
};

export const TokenSwapApi = (data) => {
  return baseAxios.post(`/collections/token_swap`, data);
};

export const TokenSwapListApi = () => {
  return baseAxios.get("/collections/token_swap_list");
};

export const NftStakingApi = ({ method, collectionId, hash }) => {
  return baseAxios.post(
    `collections/${collectionId}/${method}?transaction_hash=${hash}`
  );
};

export const BAFStakingListApi = () => {
  return baseAxios.get(`collections/token_stake_plans`);
};

export const BAFTokenStaking = ({ data, method }) => {
  return baseAxios.post(`collections/${method}`, data);
};

export const trackIP = () => axios.get("https://geolocation-db.com/json/");

export const BAFTokenStakedListApi = () => {
  return baseAxios.get(`collections/staked_token_list`);
};

export const BAFTokenUnStakeApi = (data) => {
  return baseAxios.post("collections/token_unstake", data);
};

export const userProfileUpdateApi = (data) => {
  return baseAxios.post("/users/update_profile", data);
};

export const walletCreationApi = () => {
  return baseAxios.post("/wallets");
};

export const BAFTokenBalanceApi = () => {
  return baseAxios.get("/wallets/token_balance");
};

export const writeContractApi = (data) => {
  return baseAxios.post("wallets/write_contract", data);
};

export const transactionStatusApi = (data) => {
  return baseAxios.post("wallets/transaction_status", data);
};
